<script setup>
import { computed } from 'vue';
import { useFieldErrors } from '@/composables/ruleEngine/useFieldErrors';   

const props = defineProps({
    modelValue: { type: Object, default: () => ({}) },
    errors: { type: [Array, Object], default: () => ({}) },
});
const emit = defineEmits(['update:modelValue', 'touched']);

const model = computed({
    get: () => props.modelValue || {},
    set: (val) => emit('update:modelValue', val),
});

const errorsFor = useFieldErrors(props).errorsFor;

const setNumber = (key, value) => {
    emit('touched');
    let finalValue = null;

    if (value !== '' && value !== null) {
        finalValue = Number(value);
    }

    model.value = {
        ...model.value,
        [key]: finalValue,
    };
};

const maxValue = computed({
    get: () => model.value.max_value ?? '',
    set: (val) => setNumber('max_value', val),
});
</script>

<template>
<div class="grid md:grid-cols-2 gap-4">
    <StyledInput
        v-model="maxValue"
        :label="$t('label.ltd_max_value')"
        name="max_value"
        type="number"
        :error-messages="errorsFor('max_value')" />
</div>
</template>
